// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selectGroup-sub-heading {
  font-size: 18px;
}
@media only screen and (max-width: 768px) {
  .selectGroup-sub-heading {
    font-size: 16px;
  }
}

.selectGroup-heading {
  font-size: 30px;
  padding-top: 10px;
  margin-bottom: 10px;
  font-family: "ATT Aleck Sans";
}
@media only screen and (max-width: 768px) {
  .selectGroup-heading {
    font-size: 24px;
  }
}

.list-buttons {
  margin-bottom: 15px !important;
}

#button-section {
  padding-bottom: 20px;
}

.newGroupName {
  color: #191919;
  font-size: 16px;
  width: 300px;
  background: #FFFFFF 0% 0% no-repeat padding-box !important;
  border: 1px solid #D1D2D3 !important;
  border-radius: 5px !important;
  line-height: normal;
  padding: 0 15px;
  transition: border 300ms linear 0ms;
  vertical-align: middle;
  margin-left: 35px;
  width: 300px;
}
@media only screen and (max-width: 768px) {
  .newGroupName {
    width: 290px;
  }
}

.continue-btn {
  width: 171px;
  margin-left: 19px;
}

.newGroup {
  margin-bottom: 20px;
}
@media only screen and (max-width: 768px) {
  .newGroup {
    margin-bottom: 10px;
  }
}

.existingAlert {
  color: red;
}

.notification {
  margin-left: 34px;
  margin-top: 10px;
  font-size: 14px;
  padding-right: 10px;
  width: 100%;
}
@media only screen and (max-width: 768px) {
  .btn-width {
    margin: 0;
    width: 100%;
  }
}

.text-danger {
  margin-left: 34px;
  margin-bottom: 10px;
  padding-right: 10px;
}

.subLabel {
  font-size: 14px;
  word-break: break-all;
}

#lineStyle {
  opacity: 0.5;
  margin: 0 0 34px 0;
  border: 0.5px solid #D1D2D3 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/grouping-devices/select-groups/select-groups.component.scss"],"names":[],"mappings":"AAAA;EACC,eAAA;AACD;AAAC;EAFD;IAGE,eAAA;EAGA;AACF;;AAAA;EACC,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,6BAAA;AAGD;AAFC;EALD;IAME,eAAA;EAKA;AACF;;AAFA;EACC,8BAAA;AAKD;;AAFA;EACC,oBAAA;AAKD;;AAFA;EAEA,cAAA;EACA,eAAA;EACA,YAAA;EACA,0DAAA;EACA,oCAAA;EACA,6BAAA;EACA,mBAAA;EACA,eAAA;EACA,mCAAA;EACA,sBAAA;EACA,iBAAA;EACA,YAAA;AAIA;AAFA;EAfA;IAiBC,YAAA;EAIC;AACF;;AAAA;EACC,YAAA;EACA,iBAAA;AAGD;;AAAA;EACC,mBAAA;AAGD;AAFC;EAFD;IAGE,mBAAA;EAKA;AACF;;AADA;EACC,UAAA;AAID;;AAKA;EACC,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;AAFD;AASC;EADD;IAEE,SAAA;IACA,WAAA;EANA;AACF;;AAUA;EACC,iBAAA;EACA,mBAAA;EACA,mBAAA;AAPD;;AAUA;EACC,eAAA;EACA,qBAAA;AAPD;;AAUA;EAEE,YAAA;EACA,kBAAA;EACA,sCAAA;AARF","sourcesContent":[".selectGroup-sub-heading{\n font-size: 18px;\n @media only screen and (max-width: 768px){\n  font-size: 16px;\n }\n}\n\n.selectGroup-heading{\n font-size: 30px;\n padding-top: 10px;\n margin-bottom: 10px;\n font-family: 'ATT Aleck Sans';\n @media only screen and (max-width: 768px){\n  font-size: 24px;\n }\n}\n\n.list-buttons {\n margin-bottom: 15px !important;\n}\n\n#button-section{\n padding-bottom: 20px;\n}\n\n.newGroupName{\n// display: inline-block;\ncolor: #191919;\nfont-size: 16px;\nwidth: 300px;\nbackground: #FFFFFF 0% 0% no-repeat padding-box !important;\nborder: 1px solid #D1D2D3 !important;\nborder-radius: 5px !important;\nline-height: normal;\npadding: 0 15px;\ntransition: border 300ms linear 0ms;\nvertical-align: middle;\nmargin-left: 35px;\nwidth: 300px;\n\n@media only screen and (max-width: 768px){\n//  margin-left: 0px;\n width: 290px;\n}\n\n}\n\n.continue-btn{\n width: 171px;\n margin-left: 19px;\n}\n\n.newGroup{\n margin-bottom: 20px;\n @media only screen and (max-width: 768px){\n  margin-bottom: 10px;\n\n }\n}\n\n.existingAlert{\n color:red;\n}\n\n.errorDisplay{\n // display: inline-block;\n // padding-left: 25px;\n\n}\n\n.notification{\n margin-left: 34px;\n margin-top: 10px;\n font-size: 14px;\n padding-right: 10px;\n width:100%;\n @media only screen and (max-width: 768px){\n  // margin-left: 0px;\n }\n}\n\n.btn-width{\n @media only screen and (max-width: 768px){\n  margin:0;\n  width:100%;\n  }\n\n}\n\n.text-danger{\n margin-left: 34px;\n margin-bottom: 10px;\n padding-right: 10px;\n}\n\n.subLabel{\n font-size: 14px;\n word-break: break-all;\n}\n\n#lineStyle{\n  // border: 1px #D1D2D3;\n  opacity: .5;\n  margin: 0 0 34px 0;\n  border: 0.5px solid #D1D2D3 !important;\n\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
